// removed by extract-text-webpack-plugin
module.exports = {"column":"_1dqpOwRvxEBsqC5IVuqLSL","imageContainer":"JGvO7F6EK-bXniNOpF5lT","content":"_1neHXWsLpAlYhvM_ac_A","title":"_11FAKc3ViseVigkDF35ldV"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Partners/Partner/styles.scss
 ** module id = 453
 ** module chunks = 0
 **/